import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedPlural } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";
import { OFFER_PRICE_TYPES } from "app/constants";
import { fromPriceTypeShape } from "app/utils/propTypes";
import "./ProductCardFromPrice.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ProductCardFromPrice = ({
	travelByTrainAvailable,
	value,
	pricePrefix,
	priceSuffix,
	publicPrice,
	offerPriceType,
	includeOfferWithFlight,
	publicPricePrefix,
	publicPriceSuffix,
	duration,
	showFromInfo = true,
	size = "xl",
	suffixSize = "regular",
	priceAddon,
}) => {
	const hasTransportInfo =
		includeOfferWithFlight === true &&
		(offerPriceType === OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM_WITH_FLIGHT ||
			offerPriceType === OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM);

	return (
		<div className="product-card-from-price">
			<div className="product-card-from-price__price">
				<div
					className="product-card-from-price__value"
					data-testid="product-card-from-price-value"
				>
					<Amount
						value={Number(value)}
						prefix={pricePrefix}
						prefixIsBold
						suffix={priceSuffix}
						size={size}
						suffixSize={suffixSize}
						className="product-card-from-price__amount"
					/>
					{priceAddon}
				</div>

				{publicPrice > 0 && (
					<div
						className="product-card-from-price__public-price"
						data-testid="product-card-from-price-public-price"
					>
						<Amount
							value={publicPrice}
							prefix={publicPricePrefix}
							suffix={publicPriceSuffix}
							size={size}
							suffixSize={suffixSize}
							className="product-card-from-price__amount"
						/>
					</div>
				)}
			</div>
			{showFromInfo && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.SMALL}
					variantMD={TYPOGRAPHY_VARIANTS.SMALL}
				>
					<div className="product-card-from-price__info">
						<FormattedPlural
							value={duration}
							one={
								<FormattedMessage
									id="general.duration.singular"
									values={{ duration: duration }}
								/>
							}
							other={
								<FormattedMessage
									id="general.duration.plural"
									values={{ duration: duration }}
								/>
							}
						/>
						{hasTransportInfo && ","}
						<span className="product-card-from-price__flight">
							{offerPriceType ===
								OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM_WITH_FLIGHT &&
								includeOfferWithFlight === true && (
									<span className="product-card-from-price__flight--included">
										{travelByTrainAvailable ? (
											<FormattedMessage id="general.included.transport" />
										) : (
											<FormattedMessage id="general.included.flight" />
										)}
									</span>
								)}

							{offerPriceType === OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM &&
								includeOfferWithFlight === true &&
								(!travelByTrainAvailable ? (
									<FormattedMessage id="general.excluded.flight" />
								) : (
									<FormattedMessage id="general.excluded.transport" />
								))}
						</span>
					</div>
				</Typography>
			)}
		</div>
	);
};

ProductCardFromPrice.propTypes = {
	travelByTrainAvailable: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	includeOfferWithFlight: PropTypes.bool,
	pricePrefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	priceSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	publicPricePrefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	publicPriceSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	publicPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	offerPriceType: fromPriceTypeShape,
	duration: PropTypes.number,
	showFromInfo: PropTypes.bool,
	size: PropTypes.string,
	suffixSize: PropTypes.string,
	priceAddon: PropTypes.node,
};

export default memo(ProductCardFromPrice);
